import CircularProgress from "components/circular-progress";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { neutral } from "app/themes/colors";

type MergeTagsLoadingBarProps = {
  show?: boolean;
};
export default function MergeTagsLoadingBar({
  show,
}: MergeTagsLoadingBarProps) {
  return (
    <Box
      width="100%"
      position="relative"
      sx={{
        display: show ? "block" : "none",
        opacity: show ? 0.7 : 0,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          position: "absolute",
          right: "33px",
          bottom: "18px",
          border: `solid 1px ${neutral[300]}`,
          borderRadius: "4px",
          background: neutral[50],
        }}
      >
        <CircularProgress sx={{ p: 0, transform: "scale(0.3)" }} />{" "}
        <Typography variant="caption" sx={{ pr: 2 }}>
          Initializing data for auto completion…
        </Typography>
      </Stack>
    </Box>
  );
}
